import React from 'react';
import { Navigate, Outlet } from 'react-router';
import { useAuth } from '../../../hooks/useAuth';

export function ProtectedRoute() {
  const { user, loading } = useAuth();

  if (loading) return null;
  if (!user) return <Navigate to="/" replace />;

  return <Outlet />;
}
